import { all, takeEvery, put, call } from 'redux-saga/effects'
import { notification } from 'antd'
import actions from './actions'
import workorderActions from '../workOrders/actions'
import { SAVE_200_MSG } from '../../constants'
import { save } from '../../services/protocolHistory'

export function* SaveProtocolHistory({
  contractID,
  workOrderID,
  protocolID,
  protocolAssignmentID,
  protocol1,
  protocol2,
  protocol3,
  protocol4,
  protocol5,
  protocol6,
  protocol7,
  protocol8,
  protocol9,
  protocol10,
  protocol11,
  protocol12,
}) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(
    save,
    contractID,
    workOrderID,
    protocolID,
    protocolAssignmentID,
    protocol1,
    protocol2,
    protocol3,
    protocol4,
    protocol5,
    protocol6,
    protocol7,
    protocol8,
    protocol9,
    protocol10,
    protocol11,
    protocol12,
  )
  if (result !== null && result.status === 1) {
    notification.success({
      message: SAVE_200_MSG,
      description: result.message,
    })

    // TODO:gungoromer-2025.07.08 burasi ortaklastirilmasi lazim
    yield put({
      type: workorderActions.CLOSE_POPUP_WORKORDER_PROTOCOL8_FORM,
    })
    yield put({
      type: workorderActions.CLOSE_POPUP_WORKORDER_PROTOCOL10_FORM,
    })
    yield put({
      type: workorderActions.CLOSE_POPUP_WORKORDER_PROTOCOL11_FORM,
    })

    yield put({
      type: workorderActions.FETCH_WORKORDER,
      id: workOrderID,
    })
    yield put({
      type: 'WorkOrder/CLOSE_POPUP_WORKORDER_PROTOCOL_HISTORY',
    })
  } else {
    notification.error({
      message: 'Error',
      description: result.message,
    })
  }

  yield put({
    type: actions.SAVE_PROTOCOLHISTORY_RECEIVED,
    payload: result,
  })
}

export function* SaveProtocolHistoryResetResult() {
  yield put({
    type: actions.SAVE_PROTOCOLHISTORY_RESET_RESULT_RECEIVED,
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.SAVE_PROTOCOLHISTORY, SaveProtocolHistory),
    takeEvery(actions.SAVE_PROTOCOLHISTORY_RESET_RESULT, SaveProtocolHistoryResetResult),
  ])
}
